import { Fragment } from 'react';
import type { PAGE_POSITIONS } from 'types';
import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';

type Props = {
  items: ArticleCardType[];
  modulePosition: number;
  moduleType: string;
  pagePosition: PAGE_POSITIONS;
};

const MOBILE_BLOCK_SIZE = 9;
const MOBILE_BREAK_OFFSET = 4;

function breaksTheBlock(index: number) {
  return index % MOBILE_BLOCK_SIZE === MOBILE_BREAK_OFFSET;
}

export default function Grid({
  items,
  modulePosition,
  moduleType,
  pagePosition
}: Props) {
  if (!items.length) return null;

  const shared = {
    modulePosition,
    moduleType,
    name: 'LATEST_NEWS' as const,
    pagePosition
  };

  return (
    <div className="content-width grid grid-cols-2 gap-x-2 gap-y-8 md:grid-cols-3 md:gap-x-6 md:gap-y-10">
      {items.map((item, index) =>
        breaksTheBlock(index) ? (
          <Fragment key={item.link.path}>
            <ArticleCard
              {...shared}
              className="col-span-2 md:hidden"
              item={item}
              options={{ compact: true, titleLines: 2 }}
              position={index + 1}
              variant="16/9-text-over"
            />
            <ArticleCard
              {...shared}
              className="hidden md:block"
              item={item}
              options={{ compact: true, titleLines: 3 }}
              position={index + 1}
              variant="16/9-text-under"
            />
          </Fragment>
        ) : (
          <ArticleCard
            key={item.link.path}
            {...shared}
            item={item}
            mdRatio="16:9"
            options={{ compact: true, titleLines: 3 }}
            position={index + 1}
            variant="4/5-text-under"
          />
        )
      )}
    </div>
  );
}
